import { Button } from "./components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardKicker, CardTitle } from "./components/ui/card";
import { Badge } from "./components/ui/badge";
import { PageShell, TopNav } from "./components/brand-scaffold";
import { navItems } from "./content";

export default function Demo() {
  return (
    <PageShell>
      <TopNav navItems={navItems} />
      <main className="px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl space-y-16">
          
          <section>
            <h2 className="text-4xl font-black uppercase mb-8">Buttons</h2>
            <div className="flex flex-wrap gap-6 items-end p-8 border-4 border-black bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
              <Button variant="default">Primary Default</Button>
              <Button variant="secondary">Secondary Default</Button>
              <Button variant="dark">Dark Variant</Button>
              <Button variant="destructive">Destructive</Button>
              <Button variant="outline">Outline</Button>
              <Button variant="ghost">Ghost Variant</Button>
              
              <Button size="lg">Large Size</Button>
              <Button size="sm">Sm</Button>
            </div>
          </section>

          <section>
            <h2 className="text-4xl font-black uppercase mb-8">Badges</h2>
            <div className="flex flex-wrap gap-4 p-8 border-4 border-black bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
              <Badge tone="protocol">Protocol</Badge>
              <Badge tone="client">Client</Badge>
              <Badge tone="caller">Caller</Badge>
              <Badge tone="responder">Responder</Badge>
              <Badge tone="platform">Platform</Badge>
              <Badge tone="selfhost">Selfhost</Badge>
              <Badge tone="destructive">Destructive</Badge>
              <Badge tone="neutral">Neutral</Badge>
              <Badge variant="outline">Outline</Badge>
              <Badge variant="dark">Dark Variant</Badge>
            </div>
          </section>

          <section>
            <h2 className="text-4xl font-black uppercase mb-8">Cards</h2>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              
              <Card accentColor="#A3E635">
                <CardHeader>
                  <CardKicker>Green Accent</CardKicker>
                  <CardTitle>Standard Card</CardTitle>
                  <CardDescription>A normal descriptive text in a standard card container with an accent color.</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="font-bold text-sm">Here is some generic content inside the card.</p>
                </CardContent>
                <CardFooter>
                  <Button variant="default" size="sm">Action</Button>
                </CardFooter>
              </Card>

              <Card decorativeColor="#3B82F6,#14B8A6,#F97316">
                <CardHeader>
                  <CardKicker>Client Split</CardKicker>
                  <CardTitle>Multi-color</CardTitle>
                  <CardDescription>A card displaying multiple decorative colors at the top.</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex gap-2 mb-4">
                    <Badge tone="caller">Caller</Badge>
                    <Badge tone="responder">Responder</Badge>
                  </div>
                </CardContent>
              </Card>

              <Card decorativeColor="#8B5CF6">
                <CardHeader>
                  <CardKicker>Platform</CardKicker>
                  <CardTitle>Platform Layer</CardTitle>
                  <CardDescription>Using the dedicated purple semantic surface for the platform layer.</CardDescription>
                </CardHeader>
                <CardFooter>
                  <Button variant="secondary" className="w-full">Explore</Button>
                </CardFooter>
              </Card>
              
            </div>
          </section>

        </div>
      </main>
    </PageShell>
  );
}
